import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from "react";
import axios from "axios";

var ActivationKitSearch = function ActivationKitSearch() {
  var startingStates = {
    timeToComplete: {
      name: "Time To Complete",
      slug: "",
      id: 0
    },
    activity: {
      name: "Activity",
      slug: "",
      id: 0
    },
    madeFor: {
      name: "Made For",
      slug: "",
      id: 0
    }
  };

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      filterMadeFor = _useState2[0],
      setFilterMadeFor = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filterTimeToComplete = _useState4[0],
      setFilterTimeToComplete = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      filterActivity = _useState6[0],
      setFilterActivity = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      filterMaterials = _useState8[0],
      setFilterMaterials = _useState8[1];

  var _useState9 = useState(startingStates.activity),
      _useState10 = _slicedToArray(_useState9, 2),
      activitySelected = _useState10[0],
      setActivitySelected = _useState10[1];

  var _useState11 = useState(startingStates.timeToComplete),
      _useState12 = _slicedToArray(_useState11, 2),
      timeToCompleteSelected = _useState12[0],
      setTimeToCompleteSelected = _useState12[1];

  var _useState13 = useState(startingStates.madeFor),
      _useState14 = _slicedToArray(_useState13, 2),
      madeForSelected = _useState14[0],
      setMadeForSelected = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      activationKits = _useState16[0],
      setActivationKits = _useState16[1];

  var _useState17 = useState(undefined),
      _useState18 = _slicedToArray(_useState17, 2),
      taxCheatSheet = _useState18[0],
      setTaxCheatSheet = _useState18[1];

  var resetLabelStates = function resetLabelStates() {
    setActivitySelected(startingStates.activity);
    setTimeToCompleteSelected(startingStates.timeToComplete);
    setMadeForSelected(startingStates.madeFor);
  };

  var _useState19 = useState({
    useFilters: false,
    madeFor: false,
    timeToComplete: false,
    activity: false
  }),
      _useState20 = _slicedToArray(_useState19, 2),
      appliedFilters = _useState20[0],
      setAppliedFilters = _useState20[1];

  var getTaxItems = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(taxonomy) {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.get("/wp-json/wp/v2/".concat(taxonomy, "?per_page=100")).then(function (res) {
                return res.data;
              });

            case 2:
              response = _context.sent;
              console.log("response for ".concat(taxonomy), response);
              return _context.abrupt("return", response);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getTaxItems(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var getActivationKits = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios.get("/wp-json/wp/v2/activation-kit?per_page=100&filter[orderby]=menu_order&_embed").then(function (res) {
                return res.data;
              });

            case 2:
              response = _context2.sent;
              console.log("response for Activation Kits", response);
              return _context2.abrupt("return", response);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getActivationKits() {
      return _ref2.apply(this, arguments);
    };
  }(); // const getActivationKits = async() => {
  //   console.log("getting activationKitData");
  //   const response = await axios.git('/wp-json/wp/v2/activation-kit?_embed').then((res) => res.data);
  //   // return response;
  //   console.log('activationKitData', response);
  //   setActivationKits(response);
  // }


  var initialFilters = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(taxonomies) {
      var _iterator, _step, taxonomy, items;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(taxonomies);
              _context3.prev = 1;

              _iterator.s();

            case 3:
              if ((_step = _iterator.n()).done) {
                _context3.next = 12;
                break;
              }

              taxonomy = _step.value;
              console.log("taxonomy is: ", taxonomy);
              _context3.next = 8;
              return getTaxItems(taxonomy);

            case 8:
              items = _context3.sent;

              if (taxonomy === "made-for") {
                setFilterMadeFor(items);
              } else if (taxonomy === "time-to-complete") {
                setFilterTimeToComplete(items);
              } else if (taxonomy === "activity") {
                setFilterActivity(items);
              } else if (taxonomy === 'materials') {
                setFilterMaterials(items);
              }

            case 10:
              _context3.next = 3;
              break;

            case 12:
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](1);

              _iterator.e(_context3.t0);

            case 17:
              _context3.prev = 17;

              _iterator.f();

              return _context3.finish(17);

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 14, 17, 20]]);
    }));

    return function initialFilters(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var fetchActivationKits = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var activationKits;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getActivationKits();

            case 2:
              activationKits = _context4.sent;
              setActivationKits(activationKits);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fetchActivationKits() {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchActivationKits();
    initialFilters(["made-for", "time-to-complete", "activity", 'materials']);
  }, []);
  useEffect(function () {
    var taxKeyValue = {
      madeFor: [],
      timeToComplete: [],
      activity: [],
      materials: []
    };
    filterMadeFor.map(function (item) {
      if (item && item !== null) {
        taxKeyValue.madeFor[item.id] = item;
      }
    });
    filterTimeToComplete.map(function (item) {
      if (item && item !== null) {
        taxKeyValue.timeToComplete[item.id] = item;
      }
    });
    filterActivity.map(function (item) {
      if (item && item !== null) {
        taxKeyValue.activity[item.id] = item;
      }
    });
    filterMaterials.map(function (item) {
      if (item && item !== null) {
        taxKeyValue.materials[item.id] = item;
      }
    });
    setTaxCheatSheet(taxKeyValue);
    console.log('taxKeyValue', taxKeyValue);
  }, [filterMadeFor, filterTimeToComplete, filterActivity, filterMaterials]);

  var filterClicky = function filterClicky(e, filter, setThisState) {
    e.preventDefault(); // setSelected(filter);

    console.log('filter', filter);
    e.target.parentNode.parentNode.parentNode.classList.remove('show');
    setThisState(filter);
  };

  var updateFilters = function updateFilters(e) {
    e.preventDefault();
    var newFilters = {
      useFilters: true,
      madeFor: madeForSelected.id,
      timeToComplete: timeToCompleteSelected.id,
      activity: activitySelected.id
    };
    console.log('newFilters', newFilters);
    setAppliedFilters(newFilters);
    setTimeout(function () {
      placeholderHeight();
    }, 500);
  };

  var resetFilters = function resetFilters(e) {
    e.preventDefault();
    var newFilters = {
      useFilters: false,
      madeFor: false,
      timeToComplete: false,
      activity: false
    };
    setAppliedFilters(newFilters);
    resetLabelStates();
    setTimeout(function () {
      placeholderHeight();
    }, 500);
  };

  var placeholderHeight = function placeholderHeight() {
    var placeholder = document.querySelector('.parallax-placeholder');
    var container = document.querySelector('.activation-kits-container');
    var filterSection = document.querySelector('#activation-kits-section');
    placeholder.style.height = "".concat(container.offsetHeight + 300, "px");
  };

  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetchActivationKits();

          case 2:
            setTimeout(function () {
              placeholderHeight();
            }, 500);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    id: "activation-kits-section",
    className: "activation-kits-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("p", null, "Filter Prompts"), /*#__PURE__*/React.createElement("div", {
    className: "filters-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-option"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "made-for"
  }), /*#__PURE__*/React.createElement("button", {
    className: "filter"
  }, madeForSelected.name), /*#__PURE__*/React.createElement("ul", null, filterMadeFor && filterMadeFor.map(function (filter) {
    return /*#__PURE__*/React.createElement("li", {
      key: filter.slug
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        return filterClicky(e, filter, setMadeForSelected);
      }
    }, filter.name));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "filter-option"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "time-to-complete"
  }), /*#__PURE__*/React.createElement("button", {
    className: "filter"
  }, timeToCompleteSelected.name), /*#__PURE__*/React.createElement("ul", null, filterTimeToComplete && filterTimeToComplete.map(function (filter) {
    return /*#__PURE__*/React.createElement("li", {
      key: filter.slug
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        return filterClicky(e, filter, setTimeToCompleteSelected);
      }
    }, filter.name));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "filter-option"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "Activity"
  }), /*#__PURE__*/React.createElement("button", {
    className: "filter"
  }, activitySelected.name), /*#__PURE__*/React.createElement("ul", null, filterActivity && filterActivity.map(function (filter) {
    return /*#__PURE__*/React.createElement("li", {
      key: filter.slug
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick(e) {
        return filterClicky(e, filter, setActivitySelected);
      }
    }, filter.name));
  }))), /*#__PURE__*/React.createElement("button", {
    className: "submit btn",
    onClick: function onClick(e) {
      updateFilters(e);
    }
  }, "Filter"), /*#__PURE__*/React.createElement("button", {
    className: "refresh",
    onClick: function onClick(e) {
      resetFilters(e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Refresh Filters")))), /*#__PURE__*/React.createElement("div", {
    className: "activation-kits-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, activationKits && activationKits.map(function (kit) {
    var excerpt = kit.excerpt.rendered;
    var truncated = excerpt.replace(/^(.{250}[^\s]*).*/, "$1");

    if (excerpt !== truncated) {
      excerpt = truncated + '...';
    }

    if (!appliedFilters.useFilters || (appliedFilters.madeFor !== 0 ? kit['made-for'].includes(appliedFilters.madeFor) : true) && (appliedFilters.timeToComplete !== 0 ? kit['time-to-complete'].includes(appliedFilters.timeToComplete) : true) && (appliedFilters.activity !== 0 ? kit['activity'].includes(appliedFilters.activity) : true)) {
      return /*#__PURE__*/React.createElement("div", {
        className: "exhibition-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-container load"
      }, kit._embedded && /*#__PURE__*/React.createElement("img", {
        src: kit._embedded["wp:featuredmedia"][0].source_url,
        alt: kit["_embedded"]["wp:featuredmedia"][0]["alt_text"],
        loading: "lazy"
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-container"
      }, /*#__PURE__*/React.createElement("h3", null, kit.title.rendered), /*#__PURE__*/React.createElement("div", {
        className: "info-container"
      }, kit.acf.prompt_artist && /*#__PURE__*/React.createElement("p", null, "By ", kit.acf.prompt_artist), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Time to Complete:"), kit['time-to-complete'] && kit['time-to-complete'].map(function (tax, i) {
        return taxCheatSheet && taxCheatSheet.timeToComplete[tax] && " ".concat(taxCheatSheet.timeToComplete[tax].name).concat(kit['time-to-complete'].length > i + 1 ? ', ' : ' ');
      })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Materials Needed:"), kit['materials'] && kit['materials'].map(function (tax, i) {
        return taxCheatSheet && taxCheatSheet.materials[tax] && " ".concat(taxCheatSheet.materials[tax].name).concat(kit['materials'].length > i + 1 ? ', ' : ' ');
      }))), kit.excerpt.rendered && /*#__PURE__*/React.createElement("p", {
        className: "new-works",
        dangerouslySetInnerHTML: {
          __html: excerpt
        }
      }), /*#__PURE__*/React.createElement("a", {
        href: kit.link
      }, "View Prompt ", /*#__PURE__*/React.createElement("img", {
        src: "/app/themes/ej-theme/resources/assets/images/ui-elements/circle-arrow.svg",
        alt: "",
        "aria-hidden": "true"
      }))));
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "parallax-placeholder"
  }));
};

export default ActivationKitSearch;


// WEBPACK FOOTER //
// ./scripts/react/components/ActivationKitSearch.js